import queryString from 'query-string'

function isPrintMode(){
  const { print } = queryString.parse(window.location.search)
  return print === 'true'
}

export default isPrintMode
